<template>
    <b-container fluid>
        <b-breadcrumb :items="breadcrumbItems" class="minus-gutters"></b-breadcrumb>

        <b-alert :show="messageObject.success.count"
                dismissible
                @dismissed="messageObject.success.count=0"
                @dismiss-count-down="successCountChanged"
                >{{messageObject.success.content}}
        </b-alert>
        <b-alert :show="messageObject.warning.count"
                variant="danger"
                dismissible
                @dismissed="messageObject.warning.count=0"
                @dismiss-count-down="warningCountChanged"
                >{{messageObject.warning.content}}
        </b-alert>

        <b-row align-h="center">
            <b-col md="5">
                <h2>帳號綁定</h2>
                <b-form-group label="帳號：" description="請輸入你的帳號">
                    <b-form-input v-model="user.account.value"
                                    type="text"
                                    aria-describedby="account"
                                    :state="user.account.state"
                                    required>
                    </b-form-input>
                    <b-form-invalid-feedback id="account">
                        {{user.account.message}}
                    </b-form-invalid-feedback>
                </b-form-group>

                <b-form-group label="密碼：" description="請輸入你的密碼">
                    <b-form-input v-model="user.password.value"
                                    type="password"
                                    aria-describedby="password"
                                    :state="user.password.state"
                                    required>
                    </b-form-input>
                    <b-form-invalid-feedback id="password">
                        {{user.password.message}}
                    </b-form-invalid-feedback>
                </b-form-group>

                <b-button @click="line_bind_modal" block size="lg" variant="primary">綁定</b-button>
            </b-col>
        </b-row>
        <b-modal id="modal-line-bind" ref="line_bind_modal" title="帳號綁定" @ok="handlePWDchange">
            確認綁定該帳戶?
        </b-modal>
    </b-container>
</template>
<script>
import _ from 'lodash'

    export default {
        data() {
            return {
                PassToken: this.$route.query.Token,
                breadcrumbItems: [
                    {
                        text: '首頁',
                        href: '#'
                    },
                    {
                        text: '帳號綁定',
                        active: true
                    }
                ],
                user: {
                    line_user_id: {
                        value: null,
                    },
                    account: {
                        value: null,
                        state: null,
                        message: "欄位不能為空"
                    },
                    password: {
                        value: null,
                        state: null,
                        message: "欄位不能為空"
                    }
                },
                messageObject: {
                    warning: {
                        content: null,
                        count: 0
                    },
                    success: {
                        content: null,
                        count: 0
                    },
                    dismissSecs: 5,
                },
                //取得該使用者資訊
                apiGetAccountSelf: (data) => this.userRequest.post("/API/Default/GetAccountSelf", data),
                //送出綁定請求
                apiLineBind: (data) => this.userRequest.post("/API/Default/LineBind", data)
            }
        },
        created() {
            this.checkLogin()
        },
        methods: {
            getAccountSelf(data) {
                const _this = this;
                // console.log(data)
                this.apiGetAccountSelf(data)
                .then((res)=>{
                    const json = JSON.parse(res.data)
                     //console.log(json)
                    if(json.Status){
                         let jsonData = JSON.parse(json.Data);
                         _this.user.line_user_id.value = jsonData.AC_USERID;
                    }
                })
                .catch((err)=> {
                    console.log(err)
                });
            },
            setLineBind(data) {
                // console.log(data)
                this.apiLineBind(data)
                .then((res)=>{
                    const json = JSON.parse(res.data)
                    // console.log(json)
                    // let jsonData = json.Data
                    if(json.Status)
                    {
                        //帳號綁定成功
                        //this.suceessPopUp(json.Message);
                        alert(json.Message);
                        sessionStorage.removeItem("TokenID");
                        sessionStorage.removeItem("username");
                        sessionStorage.removeItem("disposable_line");
                        this.$router.push({ path: '/login' })
                    }
                    else
                    {
                        //帳號綁定失敗
                        this.waningPopUp(json.Message);
                    }
                })
                .catch((err)=> {
                    console.log(err)
                });
            },
            checkLogin() {
                let TokenID = sessionStorage.getItem("TokenID");
                // console.log(TokenID)
                if(TokenID){
                    this.FunctionToken(this.getAccountSelf, {})
                }
                else
                {
                    alert("未有權限檢視此頁面，請登入帳號")
                    this.$router.push({ path: '/login' })
                }
            },
            waningPopUp(msg){
                this.messageObject.warning.count = this.messageObject.dismissSecs
                this.messageObject.warning.content = msg
            },
            suceessPopUp(msg){
                this.messageObject.success.count = this.messageObject.dismissSecs
                this.messageObject.success.content = msg
            },
            warningCountChanged(count) {
                this.messageObject.warning.count = count
            },
            successCountChanged(count)
            {
                this.messageObject.success.count = count
            },
            line_bind_modal: _.throttle(function() {
                // console.log("延遲")
                if( this.user.password.state==false || this.user.password.state==null )
                {
                    this.waningPopUp("請將必填欄位填寫完畢或請符合密碼格式")
                }
                else
                {
                    this.$bvModal.show("modal-line-bind")
                }
            }, 2000),
            handlePWDchange() {
                // console.log("更改密碼")

                    let obj={
                        "line_user_id": this.user.line_user_id.value,
                        "account": this.user.account.value,
                        "password": this.user.password.value,
                    }
                    // console.log(obj)
                    this.FunctionToken(this.setLineBind, obj)
            }
        },
        watch: {
            'user.password.value' (val) {
                // console.log(val)
                if(val.length==0)
                {
                    this.user.password.message = "欄位不能為空"
                    this.user.password.state = false
                }
                else if(val.length<8)
                {
                    this.user.password.message = "密碼至少8個字元"+"(" + val.length + ")"
                    this.user.password.state = false
                }
                else
                {
                    let numasc=0;
                    let charasc=0;
                    for (let i=0; i < val.length; i++)
                    {
                        let asciiNumber = val.substr(i, 1).charCodeAt()
                        // console.log(asciiNumber)
                        if (asciiNumber >= 48 && asciiNumber <= 57) {
                            numasc=1;
                        }
                        if ((asciiNumber >= 65 && asciiNumber <= 90)||(asciiNumber >= 97 && asciiNumber <= 122)) {
                            charasc=1;
                        }
                    }
                    // console.log([numasc, charasc])
                    if(numasc==0)
                    {
                        this.user.password.message = "密碼必須含有數字";
                        this.user.password.state = false;
                    }
                    else if(charasc==0)
                    {
                        this.user.password.message = "密碼必須含有字母";
                        this.user.password.state = false;
                    }
                    else
                    {
                        this.user.password.state = true;
                    }
                }
            },
        }
    }
</script>